module.exports = __webpack_public_path__ + "static/psi-a0d6f0dccf0fd162e0d7ea876f4a11de.jpg";